// extracted by mini-css-extract-plugin
export default {"container":"rp-z","brandName":"sp-z","productName":"tp-z","productNamePdpEnhancements":"up-z","breakLongProductName":"vp-z"};